import React, { useState, useEffect } from "react";
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from "@fortawesome/free-solid-svg-icons";
import * as ConfigTypes from 'config/ConfigTypes';
import DropdownWithInput from 'components/UI/DropdownWithInput/DropdownWithInput';
import "./InputDependsOnDD.scss";

const InputDependsOnDD = (props) => {
    const { el, errors, error, userInputs, isChild = false, isOne = false, setUserInputs,
        type = 'text' } = props.eObj;

    const [data, setData] = useState([]);
    const [curObj, setCurObj] = useState({});
    const [curIn, setCurIn] = useState(el.name);
    const fm = ({ id }) => props.intl.formatMessage({ id });

    const onDDCk = (el) => (ddItem) => {
        let inValue = '';
        if (data && data.length) {
            setUserInputs((prev) => {
                let nInputs = { ...prev };
                data.forEach(item => {
                    if (item.name != ddItem.name) {
                        if (prev[item.name]) {
                            inValue = prev[item.name];
                            delete nInputs[item.name]
                        }
                    }
                });
                setCurIn(ddItem.name);
                setCurObj({ ...curObj, [ddItem.name]: inValue });
                nInputs[ddItem.name] = inValue;
                console.log("LOGS: LAMTEST100 InputDependsOnDD nInputs", nInputs);
                return (nInputs);
            });
        }
    }

    const onHandleChange = (e) => {
        setUserInputs((prev) => {
            setCurObj({ ...curObj, [curIn]: e.target.value });
            return ({ ...prev, [curIn]: e.target.value });
        });
    }

    const isReadOnly = () => {
        if (el.type === ConfigTypes.INPUT_DEPENDS_ON_DD_READONLY) return true;
        return false;
    }

    useEffect(() => {
        if (el.data && el.data.length > 0) {
            let nData = el.data.map(elem => ({ name: elem, intl: `dropdown.${elem}`, value: elem }));
            setData(nData);
        }
    }, []);

    useEffect(() => {
        if (isReadOnly()) {
            data.forEach(entry => {
                if (userInputs[entry.name]) setCurIn(entry.name);
            });
        }
    }, [userInputs]);

    const showContent = ({ el }) => {
        return <div className="inputdependsondd-content">{userInputs[curIn]}</div>
    }
    return (
        <>
            <div className="inputdependsondd-formgroup">
                {el.intl && (
                    <label className={(isChild && !isOne) ? 'inputdependsondd-xs' : null}>
                        {fm({ id: el.intl })}
                        <span>
                            {el.required && <FontAwesomeIcon icon={faStar} />}
                        </span>
                    </label>)}
                <div className="forminputwidhdd-right">
                    <div className="inputdependsondd-dd-box">
                        <DropdownWithInput data={data} current={isReadOnly() ? curIn : curObj[`${el.name}`]}
                            readOnly={isReadOnly()} withLabel={el.withLabel} onDDClick={onDDCk(el)}
                            required={el.required} error={errors[`${el.name}`]} />
                    </div>
                    {isReadOnly() ? showContent({ el }) : (
                        <input className={`forminput ${errors[el.name] ? 'inputdependsondd-error' : ''}`}
                            value={curObj[curIn]} onChange={onHandleChange} type={type} />
                    )}
                </div>
            </div>
            {(error && error !== ConfigTypes.EMPTY) && <div className="inputdependsondd-msg">{error}</div>}
        </>
    )
}


export default injectIntl(InputDependsOnDD);